<h3 class="title-bar">
  <ui-icon faName="lightbulb-on" faStyle="light"></ui-icon>
  {{ titleText() }}
</h3>

@if (isLoading()) {
  <p class="suggestion-loader">
    <ui-icon faName="spinner-third" faStyle="light" animation="spin"></ui-icon>
    {{ searchForSuggestionText() }}
  </p>
} @else if (suggestion(); as model) {
  @if (model.text) {
    <p class="suggestion-text">{{ model.text }}</p>
  }

  @if (model.resources.length) {
    <div class="suggestion-resources">
      @for (resource of model.resources; track resource.reference) {
        <ui-button
          buttonStyle="outlined"
          [icon]="resource.type === 'link' ? 'arrow-up-right-from-square' : 'download'"
          iconStyle="light"
          [class.fill-width]="isMobile()"
          (clicked)="onResourceClick(resource)"
        >
          {{ resource.name }}
        </ui-button>
      }
    </div>
  }

  <div class="suggestion-actions">
    <ui-button
      buttonStyle="filled"
      [class.fill-width]="isMobile()"
      [disabled]="!isSolvedEnabled()"
      (clicked)="onSolvedClick()"
    >
      {{ solvedButtonText() }}
    </ui-button>
  </div>
}
